import api from "./api";

export const uploadAvatar = async (file: File) => {
  try {
    const formData = new FormData();
    formData.append("avatar", file); // 'avatar' is the field name, you might need to adjust based on your server's expectation

    const response = await api.post("/images/save-avatar", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Failed to upload image", error);
    throw error;
  }
};
